import { render } from "./ProjectInfo.vue?vue&type=template&id=33b818f3&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=33b818f3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b818f3"],['__file',"src/views/h5/luqiao/project/project/ProjectInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33b818f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33b818f3', __exports__)) {
    api.reload('33b818f3', __exports__)
  }
  
  module.hot.accept("./ProjectInfo.vue?vue&type=template&id=33b818f3&scoped=true", () => {
    api.rerender('33b818f3', render)
  })

}


export default __exports__